class API {
  constructor() {
    this.API_URL = "https://" + process.env.VUE_APP_API_HOST;
  }

  async getCompanySite() {
    const site = await window.localStorage.getItem("site");
    const company = await window.localStorage.getItem("company");
    return "/" + company + "/" + site;
  }

  async getUrl(url = "", queryString = "", includeCompany = false) {
    this.token = await window.localStorage.getItem("token");
    this.companyString = await this.getCompanySite();
    let rawUrl = url + (includeCompany ? this.companyString : "") + queryString;
    const response = await fetch(this.API_URL + rawUrl, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  async get(url = "") {
    this.token = await window.localStorage.getItem("token");
    const response = await fetch(this.API_URL + url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  async post(url = "", data = {}) {
    this.token = await window.localStorage.getItem("token");
    const response = await fetch(this.API_URL + url, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.token,
      },
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });

    if (response.status != 200 && response.status != 201) {
      throw "Server error: Error code is " + response.status;
    }

    return response.json(); // parses JSON response into native JavaScript objects
  }

  async enduserLogin(email, password, company) {
    let result = await this.post("/api/user/login", {
      user: email || "",
      password: password || "",
      company: company || "",
    });
    // TODO: Shouldn't respond with this, security weakness.
    if (result === "user not found") {
      return { email: "not found" };
    } else if (result === "unauthorized") {
      return { email: "unauthorized" };
    }
    return result;
  }

  async getSiteToken(siteID) {
    let result = await this.post("/api/web/store", { key: siteID });
    return result;
  }

  async loadTheme(theme) {
    let themes = Object.keys(theme);
    themes.map((colour) => {
      if (theme[colour] != null) {
        document.querySelector(":root").style.setProperty(colour, theme[colour]);
      }
    });
  }

  async getSite(routeParam) {
    this.errors = {};
    try {
      const result = await this.getSiteToken('"' + routeParam + '"');

      // Always write fresh settings — never serve stale shops from cache.
      await window.localStorage.setItem("company", result.company);
      await window.localStorage.setItem("companyName", result.name);
      await window.localStorage.setItem("site", result.site);
      await window.localStorage.setItem("shops", JSON.stringify(result.settings));

      if (result.settings[result.site].delivery_options.includes("future-pickup")) {
        await window.localStorage.setItem("futurePickup", true);
      } else {
        window.localStorage.removeItem("futurePickup");
      }

      // Preserve an existing token so the socket reconnects with the same
      // user_id and the server-side cart survives page reloads.
      if (!localStorage.getItem("token")) {
        await window.localStorage.setItem("token", result.jwt_token);
        await window.localStorage.setItem("station", result.jwt_token);
      }
    } catch (error) {
      Object.keys(error).map((code) => {
        this.errors[code] = [error[code]];
      });
    }
  }

  async searchAccounts(query) {
    return await this.getUrl("/api/search_accounts", '?group=true&start_key=["' + query + '"]&end_key=["' + query + '\ufff0"]');
  }

  async searchVouchers(query) {
    return await this.getUrl("/api/search_vouchers", '?group=true&start_key=["' + query + '"]&end_key=["' + query + '\ufff0"]');
  }

  async enduserSignup(user) {
    return await this.post("/api/enduser/signup", user);
  }

  async updateUser(user) {
    return await this.post("/api/enduser/update/" + user._id, {
      doc: user,
    });
  }

  async getUserOrders(doc) {
    return await this.post("/api/enduser/get_orders", { docs: doc });
  }

  async resetPassword(email) {
    return await this.post("/api/enduser/reset", {
      email: email,
      db: window.localStorage.getItem("company") + "_users",
    });
  }

  async updatePass(token, password) {
    return await this.post("/api/enduser/update_pass", { token: token, password: password });
  }

  async device_login(data) {
    return await this.post("/api/device/login", { code: data });
  }

	async getIntent(data) {
		return await this.post("/api/stripe/payment_intent", data);
	}

}

const enduserApi = new API();
export { enduserApi };
